module.exports = __webpack_public_path__ + "static/media/gmdtri1.efee1cd5.png";